import { createContext, useState } from "react";

const GlobalStatusContext = createContext();

export const GlobalStatusProvider = ({ children }) => {
  const [isLoadingLoginStatus, setIsLoadingLoginStatus] = useState(true);
  const [isAlertMsgOpen, setIsAlertMsgOpen] = useState(false);
  const [alertMsgData, setAlertMsgData] = useState({ msg: '' });

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [modalContent, setModalContent] = useState({});
  const [modalData, setModalData] = useState();

  const [secondModalOpen, setSecondModalOpen] = useState(false);
  const [modalSecondData, setModalSecondData] = useState();

  const handleAlertMsgSettings = (open, msg) => {
    setIsAlertMsgOpen(open);
    if (open) {
      setAlertMsgData(msg);
    } else {
      setAlertMsgData('');
    }
  }

  return (
    <GlobalStatusContext.Provider
      value={{
        isLoadingLoginStatus,
        setIsLoadingLoginStatus,
        isAlertMsgOpen,
        setIsAlertMsgOpen,
        alertMsgData,
        setAlertMsgData,
        handleAlertMsgSettings,
        drawerOpen,
        setDrawerOpen,
        mobileOpen,
        setMobileOpen,
        isModalOpen,
        setIsModalOpen,
        editMode,
        setEditMode,
        modalContent,
        setModalContent,
        modalData,
        setModalData,
        secondModalOpen,
        setSecondModalOpen,
        modalSecondData,
        setModalSecondData
      }}
    >
      {children}
    </GlobalStatusContext.Provider>
  )
}

export default GlobalStatusContext;